const HTML_STRING_PREFIX = '__diagonal_html__:';

function encodeUtf8ToBase64(value: string): string {
  const bytes = new TextEncoder().encode(value);
  const binary = Array.from(bytes, (byte) => String.fromCharCode(byte)).join('');
  return btoa(binary);
}

function decodeBase64ToUtf8(value: string): string {
  const binary = atob(value);
  const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));
  return new TextDecoder().decode(bytes);
}

export function encodeHtmlString(html: string): string {
  return `${HTML_STRING_PREFIX}${encodeUtf8ToBase64(html)}`;
}

export function isEncodedHtmlString(value: unknown): value is string {
  return typeof value === 'string' && value.startsWith(HTML_STRING_PREFIX);
}

export function decodeHtmlString(value: string): string | null {
  if (!isEncodedHtmlString(value)) {
    return null;
  }

  const encodedPayload = value.slice(HTML_STRING_PREFIX.length);
  if (!encodedPayload) {
    return null;
  }

  try {
    return decodeBase64ToUtf8(encodedPayload);
  } catch {
    return null;
  }
}
